import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ColorPaletteIcon = function ColorPaletteIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ColorPaletteIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      d: "M8 5.952A1.03 1.03 0 0 0 9.03 4.92 1.03 1.03 0 1 0 8 5.952M6.456 6.984a1.03 1.03 0 1 1-1.03-1.032c.569 0 1.03.462 1.03 1.032M10.574 8.015a1.03 1.03 0 1 0-.003-2.06 1.03 1.03 0 0 0 .003 2.06"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.93 1C4.099 1 1 4.127 1 7.975c0 3.351 2.563 6.56 6.136 7.004.64.08 1.344-.067 1.87-.435.27-.188.523-.457.666-.815.149-.37.154-.776.019-1.173a7 7 0 0 0-.354-.805l-.08-.164a4 4 0 0 1-.082-.185c.23-.061.644-.114 1.35-.112.983.002 2.02-.239 2.855-.767.851-.54 1.513-1.399 1.6-2.57.14-1.876-.454-3.631-1.705-4.916C12.025 1.75 10.181 1 7.93 1M2.647 7.975c0-2.944 2.37-5.324 5.283-5.324 1.88 0 3.273.62 4.166 1.538s1.349 2.196 1.242 3.642c-.041.55-.335.978-.838 1.296-.52.33-1.235.514-1.971.512-.866-.002-1.537.066-2.023.245a1.7 1.7 0 0 0-.7.454c-.21.235-.311.51-.332.785-.035.47.175.918.296 1.173l.125.259c.099.2.178.36.238.536l.007.03a.3.3 0 0 1-.075.069c-.154.108-.44.187-.726.15-2.7-.334-4.692-2.797-4.692-5.365m5.494 5.153v-.003z",
      clipRule: "evenodd"
    })]
  }));
};

export { ColorPaletteIcon };
